import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { STUDIO } from '../../../data/agentCommandCenter';
import { ThemeProvider } from './studioTheme';
import { StudioShell }   from './StudioShell';
import { SidebarNav }    from './sections/SidebarNav';
import { WorkspaceGrid } from './sections/WorkspaceGrid';
import { RightPanel }    from './sections/RightPanel';

export function AgentCommandCenterScreen() {
  const [selectedId,  setSelectedId]  = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState('');

  const q = searchQuery.toLowerCase().trim();

  const filteredWorkspaces = q
    ? STUDIO.workspaces.filter(w =>
        w.name.toLowerCase().includes(q) ||
        w.state.currentMission.toLowerCase().includes(q)
      )
    : STUDIO.workspaces;

  const filteredDecisions = q
    ? STUDIO.decisions.filter(d =>
        d.subject.toLowerCase().includes(q) ||
        d.from.toLowerCase().includes(q)
      )
    : STUDIO.decisions;

  const selectedWorkspace = STUDIO.workspaces.find(w => w.id === selectedId) ?? null;

  // Workspace accent color for ambient lighting — changes with selection
  const WORKSPACE_COLORS: Record<string, string> = {
    frontend:    '#61dafb',
    gameplay:    '#a855f7',
    platform:    '#22c55e',
    social:      '#f97316',
    'studio-os': '#06b6d4',
  };
  const selectedWsColor = selectedId ? (WORKSPACE_COLORS[selectedId] ?? '#7c3aed') : '#7c3aed';

  const handleSelect = (id: string) =>
    setSelectedId(prev => (prev === id ? null : id));

  return createPortal(
    <ThemeProvider>
      <StudioShell
        accentColor={selectedWsColor}
        sidebar={
          <SidebarNav
            workspaces={STUDIO.workspaces}
            selectedId={selectedId}
            onSelect={(id) => setSelectedId(id)}
          />
        }
        main={
          <WorkspaceGrid
            workspaces={filteredWorkspaces}
            production={STUDIO.production}
            mission={STUDIO.mission}
            selectedId={selectedId}
            onSelect={handleSelect}
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery}
          />
        }
        right={
          <RightPanel
            decisions={filteredDecisions}
            selectedWorkspace={selectedWorkspace}
            workspaces={STUDIO.workspaces}
            onBack={() => setSelectedId(null)}
          />
        }
      />
    </ThemeProvider>,
    document.body
  );
}
